import React, { useState, useEffect } from "react";
import { Box, Menu, MenuItem, Typography } from "@mui/material";
import { Icon } from "pepsico-ds";
import { useNavigate } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import PreferencesDrawer from "./PreferencesDrawer";
import { useSelector, useDispatch } from "react-redux";
import { darkTheme, lightTheme } from "../../theme/Theme";
import { setConfig } from "../../slices/configSlice";
import { performOktaLogout } from "../../utils/deactivatedUserSession";
import PrivacyPolicyCommon from "../../assets/privacyPolicy.pdf";
import Loading from "../../utils/Loader";
import fetchAndCacheImageName from "../../utils/fetchAndCatchImageName";
import { downloadFileToLocal } from "../../API/curatorApi";

const textstyle = {
  overflow: "hidden",
  color: "var(--Tokens-Text-Secondary, #616161)",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap", // Ensures text is truncated in one line
  fontFamily: "var(--Typography-Font-Family-Body, Inter)",
  fontSize: "var(--Font-Size-Small, 14px)",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "var(--Line-Height-Small, 20px)", // Ensures proper spacing
};
const DropdownMenu = () => {
  const [dropdownAnchor, setDropdownAnchor] = useState(null);
  const { flagUser } = useSelector((store) => store.user);
  const { External } = useSelector((store) => store.config);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [selectedMenuItem, setSelectedMenuItem] = useState(0);
  const isDarkTheme = useSelector((state) => state.theme);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Avoid running effect on empty object
    const isEmptyObject = Object.keys(flagUser || {}).length === 0;

    if (!isEmptyObject) {
      if (flagUser?.lastLoginDate == null) {
        // Covers both null and undefined

        setDrawerOpen(true);
      } else {
        setDrawerOpen(false);
      }
    }
  }, [flagUser]);

  const dispatch = useDispatch();
  const privacyPolicyUrl = PrivacyPolicyCommon;
  const handleClick = (event) => {
    setDropdownAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setSelectedMenuItem(0);
    setDropdownAnchor(null);
  };

  const handlePreferencesClick = () => {
    setSelectedMenuItem(1);
    setDrawerOpen(true);
    handleClose();
  };

  const handleFavoriteRedirect = () => {
    handleClose();
    setSelectedMenuItem(2);
    navigate("/favorites");
  };

  const logout = async () => {
    handleClose();
    setLoading(true);
    dispatch(setConfig(null));
    try {
      await performOktaLogout(External);
    } finally {
      setLoading(false);
    }
  };
  const handleUserAgrrement = async () => {
    const response = await downloadFileToLocal(0, true);
    if (response?.status === 200) {
      handleClose();
    }
  };
  return (
      <>
        {loading && <Loading />}
        <Icon
            alt="Dropdown"
            icon="arrow_drop_down"
            size="medium"
            onClick={handleClick}
            style={{
              color: isDarkTheme ? darkTheme.iconColor1 : lightTheme.iconColor1,
            }}
            data-testid="dropdown-button"
        />

        <Menu
            id="dropdown-menu"
            anchorEl={dropdownAnchor}
            open={Boolean(dropdownAnchor) && !loading}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              marginTop: "20px",
              borderRadius: 4,
              "& .MuiPaper-root": {
                backgroundColor: isDarkTheme
                    ? darkTheme.backgroundColorLayer3
                    : lightTheme.backgroundColorLayer3,
                padding: "10px",
              },
            }}
        >
          <MenuItem
              sx={{
                color: isDarkTheme ? darkTheme.iconColor1 : lightTheme.iconColor1,
              }}
              onClick={handleUserAgrrement}
          >
            {/* <a
            href={privacyPolicyUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Typography sx={textstyle}> User Agreement</Typography>
          </a> */}
            <Typography sx={textstyle}> User Agreement</Typography>
          </MenuItem>
          <MenuItem
              onClick={handlePreferencesClick}
              selected={selectedMenuItem === 1 ? true : false}
              sx={{
                color: isDarkTheme ? darkTheme.iconColor1 : lightTheme.iconColor1,
              }}
              key={1}
              data-testid="preference-button"
          >
            <Typography sx={textstyle}>Preferences</Typography>
          </MenuItem>
          <MenuItem
              onClick={handleFavoriteRedirect}
              selected={selectedMenuItem === 2 ? true : false}
              sx={{
                color: isDarkTheme ? darkTheme.iconColor1 : lightTheme.iconColor1,
              }}
              data-testid="favourties"
              key={2}
          >
            <Typography sx={textstyle}> My Favorites</Typography>
          </MenuItem>
          <MenuItem
              onClick={logout}
              sx={{
                color: isDarkTheme ? darkTheme.iconColor1 : lightTheme.iconColor1,
              }}
              key={3}
          >
            <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
            >
              <Typography sx={textstyle}>Signout</Typography>

              <LoginIcon fontSize="small" />
            </Box>
          </MenuItem>
        </Menu>

        <PreferencesDrawer
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            setDrawerOpen={setDrawerOpen}
        />
      </>
  );
};

export default DropdownMenu;